module.exports = __webpack_public_path__ + "img/ve.a5642d9b.svg";